import React, { ReactNode } from "react";
import { Translation } from "react-i18next";
import { ERROR_BOUNDARY_MSG } from '../../utilities/Constants';
import { RouteComponentProps } from 'react-router';

interface IErrorBoundary {
    hasError: boolean;
    errorMessage: string
}

export default class ErrorBoundary extends React.Component<{ loc?: any }, IErrorBoundary> {
    constructor(props: any) {
        super(props);
        this.state = { hasError: false, errorMessage: "" };
    }

    static getDerivedStateFromError(error: string) {
        return { hasError: true, errorMessage: error };
    }
    componentDidUpdate(prevProps: any) {
        if (prevProps.loc.key !== this.props.loc.key) {
            this.setState({
                hasError: false,
            })
        }
    }

    render() {
        if (this.state.hasError) {
            return <Translation>
                {
                    t => <div className="layout-container" style={{ zIndex: 999 }}>
                        <div className="onboarding p-4 mt-4">
                            <div className="p-5 onboarding-folder">
                                <p className="title">{t(ERROR_BOUNDARY_MSG)}</p>
                            </div>
                        </div>
                    </div>
                }
            </Translation>;
        }
        return this.props.children;
    }
}